import React from 'react'
import { Routes, Route } from 'react-router-dom'

import Introduction from './Introduction'
import Signup from './Signup'
import Login from './Login'
import ResetPassword from './ResetPassword'
import PageNotFound from '@common/components/PageNotFound'

export default (
  <Routes>
    <Route path='/' element={<Introduction />} />
    <Route path='/sign_up' element={<Signup />} />
    <Route path='/sign_in' element={<Login />} />
    <Route path='/sign_in/reset_password' element={<ResetPassword />} />
    <Route path='*' element={<PageNotFound />} />
  </Routes>
)
